import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store/store'
import axios from 'axios'
import BootstrapVue from 'bootstrap-vue'
import globals from './globals'
import Popper from 'popper.js'
import Echo from 'laravel-echo'

Vue.prototype.$http = axios

// Required to enable animations on dropdowns/tooltips/popovers
Popper.Defaults.modifiers.computeStyle.gpuAcceleration = false

Vue.config.productionTip = false

Vue.use(BootstrapVue)

// Global RTL flag
Vue.mixin({
  data: globals
})

window.Pusher = require('pusher-js')

window.Echo = new Echo({
  // authEndpoint: "https://localhost/masafat-user/broadcasting/auth",
  authEndpoint: 'https://myaccount.zemmitagroup.com/broadcasting/auth',
  broadcaster: 'pusher',
  key: '3976393e046b102d6cd4',
  cluster: 'eu',
  encrypted: true,
  forceTLS: true,
  auth: {
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
      'Authorization': 'Bearer ' + localStorage.getItem('token')
    }
  }
})

axios.defaults.headers.common = {
  'X-Requested-With': 'XMLHttpRequest',
  'Authorization': 'Bearer ' + localStorage.getItem('token')
}

axios.defaults.baseURL = 'https://zemmita-group.digitallibya.com/myaccount/'
// axios.defaults.baseURL = 'http://localhost/zemmita-group/myapi-2022/'

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
